export const VIEWER = "viewer";
export const ACCEPTOR = "acceptor";
